import React, { FC, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { callApi } from "./helper";
import { getBrandProject } from "../../../api/endpoints";

interface Props {
  group: any;
}

export const DistributionHeader: FC<Props> = ({ group }) => {
  const { projectId } = useParams();
  const [project, setProject] = useState<any>({});

  const fetchProject = async (id: number) => {
    const data = await callApi(getBrandProject(id));
    if (data) setProject(data);
  };

  useEffect(() => {
    if (projectId) fetchProject(parseInt(projectId, 10));
  }, [projectId]);

  return (
    <div className="w-full md:w-12/12 mx-auto flex flex-col gap-6">
      {project?.title && (
        <Typography variant="h3">
          {project?.title}
        </Typography>
      )}
      <Typography fontWeight="bold" variant="h4" fontFamily="CircularStd">
        Distribution Channels
      </Typography>
      <Box className="mt-4 flex gap-0">
        <Typography className="w-[110px] text-text-2">
          {group?.files?.length || 0} Videos
        </Typography>
        <div className="mt-3 border-t w-full border-border-token" />
      </Box>
    </div>
  );
};
